import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import BoltIcon from '@mui/icons-material/Bolt';
import DomainIcon from '@mui/icons-material/Domain';
import PrecisionManufacturingIcon from '@mui/icons-material/PrecisionManufacturing';
import LightbulbIcon from '@mui/icons-material/Lightbulb';
import BuildIcon from '@mui/icons-material/Build';
import PublicIcon from '@mui/icons-material/Public';

const iconData = [
  { icon: <BoltIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Energy' },
  { icon: <DomainIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Infrastructure' },
  { icon: <PrecisionManufacturingIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Automation' },
  { icon: <LightbulbIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Innovation' },
  { icon: <BuildIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Engineering' },
  { icon: <PublicIcon sx={{ fontSize: 60, color: '#22538bff' }} />, label: 'Solutions' },
];

const clientLogos = [
  'divislab.png',
  'ge-td.png',
  'hyosung.png',
  'l&t.png',
  'powergrid.png',
  'sagarcement.png',
  'tgspdcl.png',
  'tgtransco.png',
];

const HomePageMobile = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        overflowX: 'hidden',
        position: 'relative',
        backgroundColor: '#f9f9f9',
        ml: 'calc(-50vw + 50%)',
      }}
    >
      {/* -------------------- Innovation -------------------- */}
      <Box sx={{ py: 6, px: 3 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, color: '#22538bff', mb: 2 }}>
          Innovation
        </Typography>
        <Typography sx={{ lineHeight: 1.8, color: '#444', fontSize: '1rem' }}>
          Innovation drives everything we do, delivering solutions that are responsible,
          beneficial, and viable. Our projects positively impact communities and local
          society while minimizing environmental footprint.
        </Typography>
      </Box>

      {/* -------------------- Industry -------------------- */}
      <Box
        sx={{
          mt: 2,
          backgroundImage: `url("homepage/solar.png")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          width: '100vw',
          minHeight: '40vh',
          py: 6,
          px: 2,
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 700, color: '#22538bff', mb: 2 }}>
          Industry
        </Typography>
        <Typography sx={{ lineHeight: 1.8, color: '#444', fontSize: '1rem', mb: 4 }}>
          Anagha Engineers brings together technologies and expertise to address
          the toughest power system challenges and accelerate the global transition
          to a more resilient and reliable grid.
        </Typography>

        <Grid
          container
          justifyContent="space-between"
          alignItems="center"
          rowSpacing={3}
          columnSpacing={0}
        >
          {iconData.map((item, index) => (
            <Grid
              item
              xs={4}
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                sx={{
                  borderRadius: '50%',
                  p: 2.2,
                  transition: '0.3s',
                  '&:hover': { backgroundColor: 'rgba(34, 83, 139, 0.45)' },
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                {item.icon}
              </Box>
              <Typography sx={{ mt: 1, fontWeight: 500, color: '#333' }}>
                {item.label}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>

      {/* -------------------- Clients -------------------- */}
      <Box sx={{ py: 6, backgroundColor: '#f9f9f9', px: 3 }}>
        <Typography variant="h3" sx={{ fontWeight: 700, color: '#22538bff', mb: 2 }}>
          Clients
        </Typography>
        <Typography sx={{ color: '#444', fontSize: '1rem', lineHeight: 1.8 }}>
          We are proud to have partnered with leading organizations across industries,
          delivering innovative and sustainable solutions.
        </Typography>

        <Box
          sx={{
            mt: 4,
            display: 'flex',
            justifyContent: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          {clientLogos.map((logo, index) => {
            const lower = logo.toLowerCase();
            const isDivis = lower.includes('divis');
            const isGE = lower.includes('ge-td');
            const isSagar = lower.includes('sagarcement');
            const isTGSPDCL = lower.includes('tgspdcl');
            const isHyosung = lower.includes('hyosung');
            const isLT = lower.includes('l&t');
            const isPowerGrid = lower.includes('powergrid');

            let maxSize = '100%';
            if (isDivis) maxSize = '150%';
            else if (isGE || isSagar || isTGSPDCL) maxSize = '130%';
            else if (isHyosung || isLT) maxSize = '80%';
            else if (isPowerGrid) maxSize = '115%';

            return (
              <Box
                key={index}
                sx={{
                  width: 130,
                  height: 130,
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  borderRadius: 2,
                  backgroundColor: '#b2ebf2',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                  '& img': {
                    maxWidth: maxSize,
                    maxHeight: maxSize,
                    objectFit: 'contain',
                    transition: 'transform 0.3s ease',
                    '&:hover': { transform: 'scale(1.05)' },
                  },
                }}
              >
                <img src={`/clientlogos/${logo}`} alt={`client-${index}`} />
              </Box>
            );
          })}
        </Box>
      </Box>
    </Box>
  );
};

export default HomePageMobile;
